/**
 * A global namespace for `ScrollLock` key.
 * e.which = 145 equivalent
 */
const keyScrollLock = "ScrollLock";

export default keyScrollLock;
